import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";
import { queryParams } from "../../../utils/helper";

export const plannerApiService = createApi({
  reducerPath: "plannerApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    createPlanner: builder.mutation({
      query: ({ payload, params }) => {
        let query = queryParams(params);
        return {
          url: `planner/create${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    getPlanner: builder.query({
      query: (params) => {
        let query = queryParams(params);
        return {
          url: `planner/get${query}`,
          method: "GET",
        };
      },
    }),
  }),
});

export const { useCreatePlannerMutation, useGetPlannerQuery } =
  plannerApiService;
